import type { AudioLevel } from '../../store/appStore';

export type PauseScreenProps = {
  onContinue?: () => void;
  onGoHome?: () => void;
  audioLevel?: AudioLevel;
  onCycleAudioLevel?: () => void;
};

export type PauseScreenModel = {
  onContinue?: () => void;
  onGoHome?: () => void;
  audioLevel: AudioLevel;
  onCycleAudioLevel?: () => void;
};

export function createPauseScreenModel(props: PauseScreenProps): PauseScreenModel {
  return {
    onContinue: props.onContinue,
    onGoHome: props.onGoHome,
    audioLevel: props.audioLevel ?? 3,
    onCycleAudioLevel: props.onCycleAudioLevel,
  };
}
